import * as React from "react";

import { Button } from "@replohq/lattice/components/button/Button";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarSeparator,
  useSidebar,
} from "@replohq/lattice/components/sidebar/Sidebar";
import { cn } from "@replohq/lattice/utils/cn";
import DashboardSidebarNav from "@v2/features/dashboard/sidebar/dashboard-sidebar-nav/DashboardSidebarNav";
import { NavUser } from "@v2/features/dashboard/sidebar/NavUser";
import { ProjectSelector } from "@v2/features/dashboard/sidebar/project-selector/ProjectSelector";
import { SidebarCardCarousel } from "@v2/features/dashboard/sidebar/SidebarCardCarousel";
import { ReferralPanel } from "@v2/features/dub/ReferralPanel";
import { ChevronsLeft, ChevronsRight } from "lucide-react";

export default function DashboardSidebar({
  ...props
}: React.ComponentProps<typeof Sidebar>) {
  const { open, toggleSidebar, isMobile } = useSidebar();

  return (
    <Sidebar variant="floating" collapsible="icon" {...props}>
      <SidebarHeader UNSAFE_className="pb-0 gap-0!">
        <SidebarMenu>
          <SidebarMenuItem className="w-full" UNSAFE_className="pb-2">
            <ProjectSelector variant="sidebar" />
          </SidebarMenuItem>
        </SidebarMenu>

        <SidebarSeparator />

        {!isMobile && (
          <Button
            icon
            size="sm"
            variant="secondary"
            aria-label={open ? "Collapse sidebar" : "Expand sidebar"}
            onClick={toggleSidebar}
            UNSAFE_className={cn(
              "absolute top-[73px] right-0",
              !open && "top-[57px]",
            )}
          >
            {open ? <ChevronsLeft /> : <ChevronsRight />}
          </Button>
        )}
      </SidebarHeader>

      <SidebarContent UNSAFE_className="pt-2">
        <DashboardSidebarNav />
        <div className="px-3 mt-auto">
          <SidebarCardCarousel>
            {/* TODO (Yuxin, 2026-05-27): The "The New Replo is Here"
                ReploAIPanel has been removed; only the ReferralPanel is
                shown for now. Restore from git history to bring it back. */}
            <ReferralPanel />
          </SidebarCardCarousel>
        </div>
      </SidebarContent>

      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
